import { render } from "./ViewContact.vue?vue&type=template&id=3c49586e"
import script from "./ViewContact.vue?vue&type=script&lang=js"
export * from "./ViewContact.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__